<template>
  <div>
    <page-table :data-api="this.api.manufacturer" :viewable="false" keyField="id">
      <el-table-column prop="id" label="编号" width="80">
      </el-table-column>
      <el-table-column prop="name" label="厂商名称">
      </el-table-column>
      <el-table-column prop="description" label="厂商介绍">
      </el-table-column>
      <el-table-column prop="createDate" label="添加时间">
      </el-table-column>
    </page-table>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  created: function () {},
  methods: {}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// List.vue?842f9b12